<template>
    <v-card elevation="0">
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn
                    v-if="hasAddNewButton"
                    color="primary"
                    dark
                    class="ml-2"
                    @click="addNewItem"
                >
                    Adaugare
                </v-btn>
                <v-dialog
                    v-else
                    v-model="dialog"
                    max-width="80vw"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Adaugare
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="6">
                                        <v-select
                                            :items="accountables"
                                            v-model="form.accountable"
                                            label="Document"
                                            data-vv-as="Document"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('accountable_id')"
                                            :class="{ 'error--text': hasErrors('accountable_id') }"
                                            class="primary--text"
                                            name="accountable_id"
                                            data-vv-name="accountable_id"
                                            return-object
                                        ></v-select>
                                        <v-date-field
                                            v-model="form.payment_date"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('payment_date')"
                                            :class="{ 'error--text': hasErrors('payment_date') }"
                                            class="primary--text"
                                            name="payment_date"
                                            data-vv-name="payment_date"
                                            label="Data platii"
                                            data-vv-as="Data platii"
                                        ></v-date-field>
                                        <v-text-field
                                            v-model="form.document_no"
                                            label="Numar document"
                                            data-vv-as="Numar document"
                                            v-validate="''"
                                            :error-messages="errorMessages('document_no')"
                                            :class="{ 'error--text': hasErrors('document_no') }"
                                            class="primary--text"
                                            name="document_no"
                                            data-vv-name="document_no"
                                        ></v-text-field>
                                        <v-select
                                            :items="paymentTypes"
                                            item-text="text"
                                            item-value="value"
                                            v-model="form.method"
                                            label="Metoda de plata"
                                            data-vv-as="Metoda de plata"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('method')"
                                            :class="{ 'error--text': hasErrors('method') }"
                                            class="primary--text"
                                            name="method"
                                            data-vv-name="method"
                                        ></v-select>
                                        <v-textarea
                                            v-model="form.remarks"
                                            label="Observatii"
                                            data-vv-as="Observatii"
                                            :error-messages="errorMessages('remarks')"
                                            :class="{ 'error--text': hasErrors('remarks') }"
                                            class="primary--text"
                                            name="remarks"
                                            data-vv-name="remarks"
                                        ></v-textarea>
                                        <v-subheader class="heading-3">Date de facturare client</v-subheader>
                                        <v-text-field
                                            v-model="form.data.company_name"
                                            v-validate="'required'"
                                            label="Denumire societate / persoana"
                                            data-vv-as="Denumire societate / persoana"
                                            :error-messages="errorMessages('data.company_name')"
                                            :class="{ 'error--text': hasErrors('data.company_name') }"
                                            class="primary--text"
                                            name="data.company_name"
                                            data-vv-name="data.company_name"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="form.data.company_vat"
                                            v-validate="'required'"
                                            label="CUI / CNP"
                                            data-vv-as="CUI / CNP"
                                            :error-messages="errorMessages('data.company_vat')"
                                            :class="{ 'error--text': hasErrors('data.company_vat') }"
                                            class="primary--text"
                                            name="data.company_vat"
                                            data-vv-name="data.company_vat"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="form.data.company_rc"
                                            v-validate="'required'"
                                            label="Numar R.C / CNP"
                                            data-vv-as="Numar R.C / CNP"
                                            :error-messages="errorMessages('data.company_rc')"
                                            :class="{ 'error--text': hasErrors('data.company_rc') }"
                                            class="primary--text"
                                            name="data.company_rc"
                                            data-vv-name="data.company_rc"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="form.data.company_address"
                                            v-validate="'required'"
                                            label="Sediu social / Domiciliu"
                                            data-vv-as="Sediu social / Domiciliu"
                                            :error-messages="errorMessages('data.company_address')"
                                            :class="{ 'error--text': hasErrors('data.company_address') }"
                                            class="primary--text"
                                            name="data.company_address"
                                            data-vv-name="data.company_address"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                <tr>
                                                    <td>Cont destinatie</td>
                                                    <td>Valoare</td>
                                                    <td width="10%">
                                                        <v-btn small color="success" @click="addTransaction">
                                                            Adauga plata
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                </thead>
                                                <tbody v-if="form.transactions.length">
                                                <tr v-for="(transaction, index) in form.transactions" :key="index">
                                                    <td>
                                                        <v-select
                                                            :items="Static.accounts"
                                                            item-text="name"
                                                            item-value="id"
                                                            v-model="transaction.id"
                                                            label="Cont destinatie"
                                                            data-vv-as="Cont destinatie"
                                                            v-validate="'required'"
                                                            :error-messages="errorMessages(`transactions.${index}.id`)"
                                                            :class="{ 'error--text': hasErrors(`transactions.${index}.id`) }"
                                                            class="primary--text"
                                                            :name="`transactions.${index}.id`"
                                                            :data-vv-name="`transactions.${index}.id`"
                                                            type="number"
                                                        ></v-select>
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                            v-model="transaction.pivot.amount"
                                                            label="Valoare"
                                                            data-vv-as="Valoare"
                                                            v-validate="'required'"
                                                            :error-messages="errorMessages(`transactions.${index}.pivot.amount`)"
                                                            :class="{ 'error--text': hasErrors(`transactions.${index}.pivot.amount`) }"
                                                            class="primary--text"
                                                            :name="`transactions.${index}.pivot.amount`"
                                                            :data-vv-name="`transactions.${index}.pivot.amount`"
                                                            type="number"
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <v-icon
                                                            small
                                                            @click="deleteTransaction(index)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tbody v-else>
                                                <tr>
                                                    <td colspan="5">
                                                        <v-alert dense type="info">
                                                            Incepeti sa adaugati conturi de corespondenta.
                                                        </v-alert>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tfoot v-if="hasErrors('transactions')">
                                                <tr>
                                                    <td colspan="11" class="text-center">
                                                        <v-alert
                                                            dense
                                                            type="error"
                                                        >
                                                            <template v-for="error in errorMessages('transactions')">
                                                                {{ error }}
                                                            </template>
                                                        </v-alert>
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="close"
                            >
                                Renuntare
                            </v-btn>
                            <v-btn
                                :disabled="!_.isNil(form.id)"
                                color="blue darken-1"
                                text
                                @click="save"
                            >
                                Salveaza
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>


                <v-dialog
                    v-model="invoiceDialog"
                    max-width="30vw"
                >
                    <v-card>
                        <v-card-title>
                            <span class="headline">Generare factura</span>
                        </v-card-title>
                        <v-card-text>
                            <v-select
                                :items="availableInvoiceSerials"
                                item-text="text"
                                item-value="value"
                                v-model="invoiceForm.invoice_serial"
                                label="Serie factura"
                                data-vv-as="Serie factura"
                                v-validate="'required'"
                                :error-messages="errorMessages('invoice_serial')"
                                :class="{ 'error--text': hasErrors('invoice_serial') }"
                                class="primary--text"
                                name="invoice_serial"
                                data-vv-name="invoice_serial"
                            ></v-select>
                            <v-text-field
                                v-model="invoiceForm.text"
                                label="Produs/Serviciu"
                                data-vv-as="Produs/Serviciu"
                                v-validate="'required'"
                                :error-messages="errorMessages('text', invoiceForm.errors)"
                                :class="{ 'error--text': hasErrors('text', invoiceForm.errors) }"
                                class="primary--text"
                                name="text"
                                data-vv-name="text"
                            ></v-text-field>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="closeInvoiceDialog"
                            >
                                Renuntare
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="createInvoice"
                            >
                                Salveaza
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="computedItems"
            :options.sync="options"
        >
            <template v-slot:item.accountable_id="{ item }">
                {{ _.get(accountables.find(accountable => accountable.accountable_id === item.accountable_id), 'text') }}
            </template>
            <template v-slot:item.payment_date="{ item }">
                {{ new Date(item.payment_date) | date }}
            </template>
            <template v-slot:item.amount="{ item }">
                {{ item.amount | price }}
            </template>
            <template v-slot:item.invoice="{ item }">
                <template v-if="!_.isNil(item.invoice)">
                    {{ item.invoice.invoice_no }} / {{ new Date(item.invoice.created_at) | shortdate }}
                </template>
                <template v-else>
                    -
                </template>
            </template>
            <template v-slot:item.method="{ item }">
                {{ _.get(Static.paymentTypesConfig, item.method) }}
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ item.created_by.name }}<br/>
                {{ item.updated_by.name }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="openInvoicePopup(item)"
                >
                    mdi-file-pdf
                </v-icon>
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import swal from "sweetalert2";
    import SmartTable from "Components/SmartTable";
    import router from "../../router";
    export default {
        extends: SmartTable,
        mixins: [validationError],
        props: {
            payments: {
                type: Array,
                default () {
                    return []
                }
            },
            accountables: {
                type: Array,
                default () {
                    return []
                }
            },
            customerId: {
                type: [String, Number],
                default () {
                    return undefined
                }
            }
        },
        data: () => ({
            title: 'Incasari',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Contract', value: 'accountable_id' },
                { text: 'Data', value: 'payment_date' },
                { text: 'Nr Document', value: 'document_no' },
                { text: 'Valoare', value: 'amount' },
                { text: 'Metoda de plata', value: 'method' },
                { text: 'Numar factura', value: 'invoice' },
                { text: 'Adaugat/Creat de', value: 'created_by' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            form: new Form({
                id: null,
                accountable_type: null,
                accountable_id: null,
                accountable: {
                    accountable_type: null,
                    accountable_id: null,
                },
                document_no: null,
                amount: null,
                method: null,
                remarks: null,
                payment_date: null,
                transactions: [],
                data: {
                    company_address: null,
                    company_name: null,
                    company_rc: null,
                    company_vat: null
                }
            }),
            defaultItem: {
                id: null,
                accountable_type: null,
                accountable_id: null,
                accountable: {
                    accountable_type: null,
                    accountable_id: null,
                },
                document_no: null,
                amount: null,
                method: null,
                remarks: null,
                payment_date: null,
                transactions: [],
                data: {
                    company_address: null,
                    company_name: null,
                    company_rc: null,
                    company_vat: null
                }
            },

            invoiceDialog: false,
            invoiceForm: new Form({
                invoice_no: null,
                invoice_serial: null,
                text: null,
            })
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare plata' : 'Modificare plata'
            },
            paymentTypes() {
                const types = this.Static.paymentTypesConfig
                return Object.keys(types).map((typeKey) => {
                    return {
                        value: typeKey,
                        text: types[typeKey]
                    }
                })
            },
            computedItems() {
                return this.items.map((payment) => {
                    const foundType = this.accountables.find(accountable => accountable.accountable_id === payment.accountable_id && accountable.accountable_type === payment.accountable_type)
                    payment.accountable = {
                        accountable_type: payment.accountable_type,
                        accountable_id: payment.accountable_id,
                        text: this._.get(foundType, 'text', `Nedefinit (${payment.accountable_type} - ${payment.accountable_id})`)
                    }
                    return payment
                })
            },
            availableInvoiceSerials() {
                const workstation = this.$store.getters['workstation/getWorkstation']
                return (workstation?.data?.company_invoice_prefix ?? '')
                    .split(',')
                    .map(serial => {
                        return {text: serial, value: serial}
                    })
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            payments: {
                handler(val) {
                    this.items = val
                },
                deep: true
            },
            'form.accountable': {
                handler(val) {
                    this.form.data.company_address = this._.get(val, 'data.company_address')
                    this.form.data.company_name = this._.get(val, 'data.company_name')
                    this.form.data.company_rc = this._.get(val, 'data.company_rc')
                    this.form.data.company_vat = this._.get(val, 'data.company_vat')
                },
                deep: true
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            initialize(){
                this.items = this.payments
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.form = new Form(Object.assign({}, item))
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                var userModel = await new this.$db.Customer({id: this.customerId});
                new this.$db.Payment({ id: item.id })
                    .for(userModel)
                    .delete()
                    .then(() => {
                        this.$emit('refresh')
                    })
                this.dialogDelete = false
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            save () {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;

                var userModel = await new this.$db.Customer({id: this.customerId});

                if (this.id) {
                    model.id = this.id
                }

                new this.$db.Payment(self.form)
                    .for(userModel)
                    .save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                    }).then(() => {
                        this.$emit('refresh')
                        this.close()
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError(errors.response?.data?.message)
                    }).finally(() => {
                    });
            },
            addTransaction() {
                this.form.transactions.push({
                    id: null,
                    name: null,
                    pivot: {
                        amount: null
                    }
                })
            },
            deleteTransaction(index) {
                this.form.transactions.splice(index, 1)
            },
            openInvoicePopup(item) {
                this.invoicedItem = item
                if (this._.isNil(item.invoice)) {
                    this.invoiceForm.text = `Prestari servicii conform ${item.accountable.text}`
                    this.invoiceDialog = true
                } else {
                    this.createInvoice()
                }
            },
            closeInvoiceDialog(item) {
                this.invoicedItem = null
                this.invoiceDialog = false
            },
            async createInvoice() {
                let self = this
                if(this._.isNil(this.invoicedItem.invoice)) {
                    this.invoicedItem.invoice = await new this.$db.Invoice(Object.assign(this.invoiceForm, {customer_id: this.customerId, payment_id: this.invoicedItem.id}))
                        .save()
                        .catch(errors => {
                            self.invoiceForm.errors.set(this.invoiceForm.extractErrors(errors.response))
                            this.showError(errors.response?.data?.message)
                        })
                }
                if(this._.isNil(this.invoicedItem.invoice)) return
                const downloadEndpoint = new this.$db.Invoice({id: this.invoicedItem.invoice.id}).downloadEndpoint
                this.loading = true
                return window.axios.get(`${downloadEndpoint}`, {
                    responseType: 'blob'
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.invoicedItem = null
                    this.invoiceDialog = false
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            }
        },
    };
</script>
